import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "more--sprite",
  "use": "more--sprite-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"more--sprite\">\n<path d=\"M13.1663 8.66667H9.16634V12.6667H7.83301V8.66667H3.83301V7.33333H7.83301V3.33333H9.16634V7.33333H13.1663V8.66667Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol